module.exports = __webpack_public_path__ + "static/img/chayin.db8a821.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/chayin.png
// module id = nRjt
// module chunks = 1